import { combineReducers } from 'redux';
import draft from './reducers/draft';
import category from './reducers/category';
import syi from './reducers/syi';
import errors from './reducers/errors';
import shipping from './reducers/shipping/shipping-reducer';
import template from './reducers/template';
import buyerRegion from './reducers/buyer-region';
import itemCondition from './reducers/item-condition';
import campaignCode from './reducers/campaign-code';
import fees from './reducers/fees';
import itemDuration from './reducers/item-duration';
import shortDescription from './reducers/short-description';
import extraFeatures from './reducers/extra-features';
import images from './reducers/images';
import price from './reducers/price';
import edit from './reducers/edit';
import longDescription from './reducers/long-description';
import scroll from './reducers/scroll';
import charityCampaign from './reducers/charity-campaign';
import attributes from './reducers/attributes';
import language from './reducers/language';
import traderaStateBankId from 'tradera/components/bank-id/state/bank-id/reducer';
import memberConsent from './reducers/member-consent';
import preview from './reducers/preview';
import charity from './reducers/charity';
import predictions from './reducers/predictions-reducer';

export default combineReducers({
    attributes,
    bankId: traderaStateBankId,
    buyerRegion,
    campaignCode,
    category,
    charity,
    charityCampaign,
    draft,
    edit,
    errors,
    extraFeatures,
    fees,
    images,
    itemCondition,
    itemDuration,
    language,
    longDescription,
    memberConsent,
    preview,
    price,
    scroll,
    shipping,
    shortDescription,
    syi,
    predictions,
    template
});
